import { useMemo } from 'react';
import { useSessionServiceContext } from '@cld/session-service';
import { useRemoteState } from '@cld/use-promise-state';
import { initializeThumbnailsSession, resolveThumbnailsCredentials } from '../api/apiThumbnails';

export const getEnvFromHost = (host: string) => {
  return host.split('.')[0] || 'console';
};

export const useAuthorizeThumbnailsClient = (cloudName: string) => {
  const { authorizedFetch } = useSessionServiceContext();
  const environmentHost = getEnvFromHost(window.location.host);
  const authorizedResolveThumbnailsCredentials = resolveThumbnailsCredentials(authorizedFetch);
  const authorizedInitializeThumbnailsSession = initializeThumbnailsSession(window.fetch);
  return useMemo(
    () => async () => {
      const { host, token } = await authorizedResolveThumbnailsCredentials(environmentHost);
      // Sets authorization cookie
      await authorizedInitializeThumbnailsSession(host, cloudName, token);

      return { host, cloudName };
    },
    [cloudName] // Thumbnail service creates auth session per cloud – no need to add more items to hook dependency list
  );
};

export const useThumbnailsAuthorization = (cloudName: string) => {
  const thumbnailsAuthorizationClient = useAuthorizeThumbnailsClient(cloudName);
  return useRemoteState(thumbnailsAuthorizationClient).state;
};

export const useThumbnailsVisibilityProtection = () => {
  return true;
};
